// extracted by mini-css-extract-plugin
export default {"AddItem":"AddItem_AddItem__wdfNJ","form":"AddItem_form__tpRLJ"};